import { optionField, stringField, numberField } from 'common/utils/form/fieldTypes';

const configPerType = curr => {
  switch (curr.label) {
    case 'date_joined':
      return {
        type_id: stringField({ initialValue: curr.id }),
        threshold: numberField({ required: true }),
        rank: optionField({ required: true }),
        second_rank: optionField()
      };
    default:
      return {
        type_id: stringField({ initialValue: curr.id }),
        aggregation_type: optionField({ required: true }),
        threshold: numberField({ required: true }),
        rank: optionField({ required: true }),
        second_rank: optionField()
      };
  }
};

const initialFields = {
  remarks: stringField(),
  vessels: optionField(),
  name: stringField({ required: true })
};

export const constructConfig = matrixRuleTypes => {
  return matrixRuleTypes?.length
    ? matrixRuleTypes.reduce(
        (acc, curr) => ({
          ...acc,
          ...initialFields,
          [curr.label]: configPerType(curr)
        }),
        {}
      )
    : initialFields;
};
